// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1Neo4jServerHealthType } from './V1Neo4jServerHealthType';
import {
  V1Neo4jServerHealthTypeFromJSON,
  V1Neo4jServerHealthTypeFromJSONTyped,
  V1Neo4jServerHealthTypeToJSON,
  V1Neo4jServerHealthTypeToJSONTyped,
} from './V1Neo4jServerHealthType';
import type { V1DatabaseMode } from './V1DatabaseMode';
import {
  V1DatabaseModeFromJSON,
  V1DatabaseModeFromJSONTyped,
  V1DatabaseModeToJSON,
  V1DatabaseModeToJSONTyped,
} from './V1DatabaseMode';
import type { V1Neo4jServerStateType } from './V1Neo4jServerStateType';
import {
  V1Neo4jServerStateTypeFromJSON,
  V1Neo4jServerStateTypeFromJSONTyped,
  V1Neo4jServerStateTypeToJSON,
  V1Neo4jServerStateTypeToJSONTyped,
} from './V1Neo4jServerStateType';

/**
 *
 * @export
 * @interface V1ServerStatus
 */
export interface V1ServerStatus {
  /**
   *
   * @type {string}
   * @memberof V1ServerStatus
   */
  address?: string;
  /**
   *
   * @type {V1Neo4jServerHealthType}
   * @memberof V1ServerStatus
   */
  health?: V1Neo4jServerHealthType;
  /**
   *
   * @type {Array<string>}
   * @memberof V1ServerStatus
   */
  hosting?: Array<string>;
  /**
   *
   * @type {V1DatabaseMode}
   * @memberof V1ServerStatus
   */
  modeConstraint?: V1DatabaseMode;
  /**
   *
   * @type {string}
   * @memberof V1ServerStatus
   */
  name?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof V1ServerStatus
   */
  requestedHosting?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof V1ServerStatus
   */
  serverId?: string;
  /**
   *
   * @type {V1Neo4jServerStateType}
   * @memberof V1ServerStatus
   */
  state?: V1Neo4jServerStateType;
  /**
   *
   * @type {string}
   * @memberof V1ServerStatus
   */
  version?: string;
}

/**
 * Check if a given object implements the V1ServerStatus interface.
 */
export function instanceOfV1ServerStatus(
  value: object,
): value is V1ServerStatus {
  return true;
}

export function V1ServerStatusFromJSON(json: any): V1ServerStatus {
  return V1ServerStatusFromJSONTyped(json, false);
}

export function V1ServerStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ServerStatus {
  if (json == null) {
    return json;
  }
  return {
    address: json['Address'] == null ? undefined : json['Address'],
    health:
      json['Health'] == null
        ? undefined
        : V1Neo4jServerHealthTypeFromJSON(json['Health']),
    hosting: json['Hosting'] == null ? undefined : json['Hosting'],
    modeConstraint:
      json['ModeConstraint'] == null
        ? undefined
        : V1DatabaseModeFromJSON(json['ModeConstraint']),
    name: json['Name'] == null ? undefined : json['Name'],
    requestedHosting:
      json['RequestedHosting'] == null ? undefined : json['RequestedHosting'],
    serverId: json['ServerId'] == null ? undefined : json['ServerId'],
    state:
      json['State'] == null
        ? undefined
        : V1Neo4jServerStateTypeFromJSON(json['State']),
    version: json['Version'] == null ? undefined : json['Version'],
  };
}

export function V1ServerStatusToJSON(json: any): V1ServerStatus {
  return V1ServerStatusToJSONTyped(json, false);
}

export function V1ServerStatusToJSONTyped(
  value?: V1ServerStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Address: value['address'],
    Health: V1Neo4jServerHealthTypeToJSON(value['health']),
    Hosting: value['hosting'],
    ModeConstraint: V1DatabaseModeToJSON(value['modeConstraint']),
    Name: value['name'],
    RequestedHosting: value['requestedHosting'],
    ServerId: value['serverId'],
    State: V1Neo4jServerStateTypeToJSON(value['state']),
    Version: value['version'],
  };
}
